// extracted by mini-css-extract-plugin
module.exports = {"container":"AppFrame_container__icl_0"};